import * as types from './actionTypes';
import changePasswordApi from '../api/changePasswordApi';
import Swal from 'sweetalert2'

export function doChangePassword(data) {

    return{
        type: types.DO_CHANGEPASSWORD,
        data
    };
}

export function doChangePasswordRes(user) {
    return{
        type: types.DO_CHANGEPASSWORD_RES,
        user
    };
}

export function passwordChange(data) {
    return function (dispatch) {
        changePasswordApi.doChangePassword(data).then(res => {
             dispatch(doChangePasswordRes(res));
             if (res.result === true) {
                Swal.fire({
                    title: res.msg,
                    icon: 'success',
                    //   confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1000
                })
              } else{
                Swal.fire({
                    title: res.msg,
                    icon: 'error',
                    //   confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1000
                })
            }
        }).catch(error => {
            return error
        });
    };
}